export let cookie = {
	set(name, value, days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	},
	get(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == " ") c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},
	delete(name) {
		document.cookie = name + "=; Max-Age=-99999999;";
	},
};

export function getParameterByName(name, url) {
	url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function focusAndOpenKeyboard(el, timeout) {
	if (!timeout) {
		timeout = 100;
	}
	if (el) {
		// Align temp input element approximately where the input element is
		// so the cursor doesn't jump around
		var __tempEl__ = document.createElement("input");
		__tempEl__.style.position = "absolute";
		__tempEl__.style.top = el.offsetTop + 7 + "px";
		__tempEl__.style.left = el.offsetLeft + "px";
		__tempEl__.style.height = 0;
		__tempEl__.style.opacity = 0;
		// Put this temp element as a child of the page <body> and focus on it
		document.body.appendChild(__tempEl__);
		__tempEl__.focus();

		// The keyboard is open. Now do a delayed focus on the target element
		setTimeout(function () {
			el.focus();
			el.click();
			// Remove the temp element
			document.body.removeChild(__tempEl__);
		}, timeout);
	}
}

export function validatePhoneNumber(phone) {
	const regex = new RegExp(MOBILE_REGEX);
	return regex.test(phone);
}
